import { useMemo } from "react";
import futureSecuritiesStore from "@/store/futureSecuritiesStore";
import { findFutureSecurityBySymbol } from "@/store/futureSecuritiesStoreACTIONS";
import tradeFromScratchStore, {
  IFutureTicket,
  returnEmptyFutureTicket,
} from "@/store/tradeFromScratchStore";
import {
  FUTURE_TICKET_REQUIRED_KEYS,
  returnMissingFutureTicketEntries,
} from "../helper/futureTicketHelper";

// One future ticket by id: the stored ticket, its updater and what derives from it.
export function useFutureTicket(ticketId: string) {
  const storedTicket = tradeFromScratchStore(
    (state) => state.futureTicketsByTicketId[ticketId],
  );
  const updateTicket = tradeFromScratchStore(
    (state) => state.updateFutureTicket,
  );
  // Subscribed so the ticket re-renders when the contracts land after it mounts.
  const futureSecurities = futureSecuritiesStore(
    (state) => state.futureSecurities,
  );

  const emptyTicket = useMemo(() => returnEmptyFutureTicket(), []);
  const ticket = storedTicket ?? emptyTicket;

  return {
    ticket,
    updateFutureTicket: (changes: Partial<IFutureTicket>) =>
      updateTicket(ticketId, changes),
    futureSecurities,
    contract: findFutureSecurityBySymbol(ticket.bloombergSymbol),
    missingEntries: returnMissingFutureTicketEntries(ticket),
    requiredKeys: FUTURE_TICKET_REQUIRED_KEYS,
  };
}
